import { useMemo } from 'react'
import { useSearch } from '@faststore/sdk'
import ProductGridSkeleton from 'src/components/skeletons/ProductGridSkeleton'
import ProductCard from 'src/components/restructure/product/ProductCard'
import type { Product } from 'src/components/restructure/product/types/product'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import './product-grid.scss'

interface Props {
  products: Product[]
  page: number
  pageSize: number
  totalCountOfRegisters: number
  type?: string
  title?: string
}

function ProductGrid({
  products,
  totalCountOfRegisters,
  type,
  title,
}: Readonly<Props>) {
  const {
    state: { term, sort, page, selectedFacets, base },
    itemsPerPage,
  } = useSearch()

  const { pageData } = useGlobalContext()

  const amplitudeData = useMemo(() => {
    return {
      term,
      sort,
      page: page === 0 ? 1 : page,
      selectedFacets,
      itemsPerPage,
      totalCountOfRegisters,
      base,
    }
  }, [
    term,
    sort,
    page,
    selectedFacets,
    itemsPerPage,
    totalCountOfRegisters,
    base,
  ])

  return (
    <ProductGridSkeleton loading={!products.length}>
      {products.map((product, idx: number) => (
        <li key={`${idx}_${product.productId}`}>
          <ProductCard
            index={idx}
            key={`${idx}_${product.productId}`}
            product={product as unknown as Product}
            amplitudeData={amplitudeData}
            type={type}
            title={title}
            shelfRef={pageData.currentPageName}
            productNameWrapper="h2"
          />
        </li>
      ))}
    </ProductGridSkeleton>
  )
}

export default ProductGrid
